(function() {
  function parseCents(value) {
    const cents = parseInt(value, 10);
    return Number.isFinite(cents) ? cents : 0;
  }

  function parseOptionalCents(value) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const cents = parseInt(value, 10);
    return Number.isFinite(cents) ? cents : null;
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }

    return `$${(cents / 100).toFixed(2)}`;
  }

  function ensureBaseLabel(option) {
    if (!option.dataset.baseLabel) {
      option.dataset.baseLabel = option.textContent.replace(/\s*[\+\-]\s*\$[\d,.]+\s*$/g, '').trim();
    }

    return option.dataset.baseLabel;
  }

  function formatPriceDifference(cents) {
    return cents % 100 === 0 ? cents / 100 : (cents / 100).toFixed(2);
  }

  function updateDropdownPriceDiffs(container) {
    const dropdownSelector = container.querySelector('.single-option-selector');
    if (!dropdownSelector) {
      return;
    }

    // Cuetec butt-only pages use the native selector solely for variant choice, not price education.
    const shouldHideNativePriceModifiers = container.dataset.bbHideNativePriceModifiers === 'true';
    const lowestProductPrice = parseCents(dropdownSelector.dataset.lowestProductPrice);

    dropdownSelector.querySelectorAll('option').forEach(option => {
      const baseLabel = ensureBaseLabel(option);
      const priceDifference = parseCents(option.dataset.variantPrice) - lowestProductPrice;

      if (!shouldHideNativePriceModifiers && priceDifference > 0) {
        option.textContent = `${baseLabel} +$${formatPriceDifference(priceDifference)}`;
        return;
      }

      option.textContent = baseLabel;
    });
  }

  function setRowVisibility(row, isVisible) {
    if (!row) {
      return;
    }

    row.style.display = isVisible ? '' : 'none';
  }

  function updatePriceDisplay(container, priceCents, compareAtPriceCents) {
    const productPriceElement = container.querySelector('.mutable-product-price');
    const comparePriceElement = container.querySelector('.mutable-compare-price');
    const savingPriceElement = container.querySelector('.mutable-saving-price');
    const listPriceRow = container.querySelector('.list-price');
    const savingPriceRow = container.querySelector('.saving-price');
    const hasCompareAtPrice = compareAtPriceCents > priceCents;

    if (productPriceElement) {
      productPriceElement.textContent = formatMoney(priceCents);
    }

    setRowVisibility(listPriceRow, hasCompareAtPrice);
    setRowVisibility(savingPriceRow, hasCompareAtPrice);

    if (!hasCompareAtPrice) {
      return;
    }

    if (comparePriceElement) {
      comparePriceElement.textContent = formatMoney(compareAtPriceCents);
    }

    if (savingPriceElement) {
      savingPriceElement.textContent = formatMoney(compareAtPriceCents - priceCents);
    }
  }

  function getSelectedVariantData(masterSelect) {
    if (!masterSelect) {
      return null;
    }

    const selectedOption = masterSelect.options[masterSelect.selectedIndex] || masterSelect.querySelector('option[selected]');
    if (!selectedOption) {
      return null;
    }

    const price = parseOptionalCents(selectedOption.getAttribute('data-variant-price'));
    if (price === null) {
      return null;
    }

    const compareAtPrice = parseOptionalCents(selectedOption.getAttribute('data-variant-compare-at-price'));

    return {
      price,
      compareAtPrice: compareAtPrice === null ? 0 : compareAtPrice
    };
  }

  function bindPriceUpdates(container) {
    const masterSelect = container.querySelector('.product-form__variants');
    if (!masterSelect || typeof window.jQuery !== 'function') {
      return;
    }

    // The hidden master select always reflects the real resolved variant, unlike the visible option rows.
    const $container = window.jQuery(container);
    const $masterSelect = window.jQuery(masterSelect);

    $container
      .off('variantChange.bbDynamicVariantPrice')
      .on('variantChange.bbDynamicVariantPrice', function(event) {
        if (!event.variant) {
          return;
        }

        updatePriceDisplay(container, parseCents(event.variant.price), parseCents(event.variant.compare_at_price));
      });

    $masterSelect
      .off('change.bbDynamicVariantPrice')
      .on('change.bbDynamicVariantPrice', function() {
        const selectedVariant = getSelectedVariantData(masterSelect);
        if (!selectedVariant) {
          return;
        }

        updatePriceDisplay(container, selectedVariant.price, selectedVariant.compareAtPrice);
      });

    const initialVariant = getSelectedVariantData(masterSelect);
    if (initialVariant) {
      updatePriceDisplay(container, initialVariant.price, initialVariant.compareAtPrice);
    }
  }

  function initDynamicVariantPrice(container) {
    updateDropdownPriceDiffs(container);
    bindPriceUpdates(container);
  }

  function init() {
    document.querySelectorAll('.product-template__container[data-section-type="product"]').forEach(initDynamicVariantPrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
